import React, { useEffect, useState } from "react";
import Loader from "./Loader";
import { TailSpin } from "react-loader-spinner";
import UserList from "./UserList";
import Pagination from "./Pagination";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import editIcon from "../images/editIcon.svg";
import unarchiveIcon from "../images/unarchive.svg";
import deleteIcon from "../images/deleteIcon.svg";
import moment from "moment";
import DefaultEmployeeProfile from "../images/DefaultEmployeeProfile.svg";
import archive from "../images/archive.svg";
import Search from "./Search";
import { fetchUsers, fetchUserCount } from "../services/UserService";
import "../styles/AdminPanel.css";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import addEmployeeIcon from "../images/addEmployeeIcon.svg";
import date from "../images/date.svg";
import printer from "../images/printer.svg";
import people from "../images/people.svg";
import history from "../images/history.svg";
import { useAuth } from "../auth/auth";
import { isAdmin } from "../utils/rbac";
import { PERMISSIONS } from "../utils/rbac";
import {
  deniedActionClass,
  usePermissionGuard,
} from "../hooks/usePermissionGuard";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
const apiUrl = process.env.REACT_APP_API_URL;

function Dashboard() {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(15);
  const [currentPagePrinted, setCurrentPagePrinted] = useState(1);
  const [pageSizePrinted] = useState(15);
  // const [startDateSent, setStartDateSent] = useState(null);
  const [totalPrintedUsers, setTotalPrintedUsers] = useState(0);
  const [showUserList, setShowUserList] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [showAllUsers, setShowAllUsers] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [rangeId, setRangeId] = useState(null);
  const [userListLoading, setUserListLoading] = useState(false);
  const [printedListLoading, setprintedListLoading] = useState(false);
  const [archivedListLoading, setarchivedListLoading] = useState(false);
  const [printedList, setPrintedList] = useState([]);
  const [archivedList, setArchivedList] = useState([]);
  const [totalArchivedUsers, setTotalArchivedUsers] = useState([]);
  const [currentPageArchived, setCurrentPageArchived] = useState(1);
  const [pageSizeArchived] = useState(15);
  const [rangeData, setRangeData] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [percentageValue, setPercentageValue] = useState(0);
  const [previousRanges, setPreviousRanges] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [currentActive, setCurrentActive] = useState("active");
  const [toBePrintedListCount, setToBePrintedListCount] = useState(0);
  const [bufferRange, setBufferRange] = useState(null);
  const [bufferPendingCount, setBufferPendingCount] = useState(0);
  const [bufferToBePrintedListCount, setBufferToBePrintedListCount] =
    useState(0);
  const [bufferPercentageValue, setBufferPercentageValue] = useState(0);
  const [totalPayout, setTotalPayout] = useState(0);
  const [bufferTotalPayout, setBufferTotalPayout] = useState(0);
  const [isArchivedOpen, setIsArchivedOpen] = useState(false);
  const [message, setMessage] = useState(null);
  const [isYtdModalOpen, setIsYtdModalOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [editedYtdAmount, setEditedYtdAmount] = useState("");
  const [currentInvoiceData, setCurrentInvoiceData] = useState(null);
  const [pendingNameQuery, setPendingNameQuery] = useState("");
  const [printedNameQuery, setPrintedNameQuery] = useState("");
  const [archivedNameQuery, setArchivedNameQuery] = useState("");
  const params = new URLSearchParams(window.location.search);
  const urlStartDate = params.get("rangeId");
  useAuth();
  const navigate = useNavigate();
  const { guardAction, PermissionDialog, isAllowed } = usePermissionGuard();
  const canDeleteInvoice = isAllowed(PERMISSIONS.DELETE);
  const canArchiveInvoice = isAllowed(PERMISSIONS.ARCHIVE);
  const canEditInvoice = isAllowed(PERMISSIONS.EDIT);
  const canManageYtd = isAllowed(PERMISSIONS.MANAGE_YTD);
  const canGeneratePdf = isAllowed(PERMISSIONS.GENERATE_PDF);

  const updateCurrentDate = async (startDateRange) => {
    if (isAdmin()) {
      try {
        const response = await axios.get(`${apiUrl}/updateCurrentDate`);
        if (response.status !== 200) {
          console.error(`Unexpected status code: ${response.status}`);
        }
      } catch (error) {
        console.error("Failed to update current date:", error);
      }
    }

    await getRangeDateData(startDateRange);
  };
  const getRangeDateData = async (startDateRange) => {
    try {
      setIsLoading(true);
      let response;
      if (startDateRange != "") {
        response = await axios.post(`${apiUrl}/getRangeDateData`, {
          startDate: startDateRange,
        });
      } else {
        response = await axios.post(`${apiUrl}/getRangeDateData`);
      }
      const data = response.data;
      // console.log(data.currentRange);
      setRangeId(data.currentRange.id);
      setStartDate(data.currentRange.start_date);
      setEndDate(data.currentRange.end_date);
      setTotalUsers(data.currentRange.total_users);
      setCurrentActive(data.currentRange.current_active);
      setPendingCount(data.currentRange.pendingCount);
      setToBePrintedListCount(data.currentRange.toBePrintedListCount);
      setTotalPayout(Number(data.currentRange.totalPayout || 0));
      const percentage =
        data.currentRange.total_users > 0
          ? (data.currentRange.toBePrintedListCount /
              data.currentRange.total_users) *
            100
          : 0;
      // console.log(percentage);
      setPercentageValue(percentage.toFixed(2));

      const otherRanges = Array.isArray(data.otherRanges)
        ? data.otherRanges
        : [];

      // Compute Buffer range: most recent completed range whose end_date
      // is within the last 3 days from today (diffDays 1, 2, or 3).
      let candidate = null;

      if (otherRanges.length > 0) {
        const today = new Date();
        const todayDateOnly = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        );

        otherRanges.forEach((range) => {
          if (!range.end_date) return;
          const end = new Date(range.end_date);
          const endDateOnly = new Date(
            end.getFullYear(),
            end.getMonth(),
            end.getDate()
          );

          const diffMs = todayDateOnly - endDateOnly;
          const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

          // Completed (end_date before today). For strict 3 days, use:
          if (diffDays > 0 && diffDays <= 3) {
            // if (diffDays > 0 /* && diffDays <= 3 */) {
            if (
              !candidate ||
              new Date(range.end_date) > new Date(candidate.end_date)
            ) {
              candidate = range;
            }
          }
        });
      }

      if (candidate) {
        const totalUsersBuffer = Number(candidate.total_users || 0);
        const totalInvoicesBuffer = Number(
          candidate.total_invoice_generated || 0
        );
        const pendingBuffer = Math.max(
          0,
          totalUsersBuffer - totalInvoicesBuffer
        );
        const toBePrintedBuffer = totalInvoicesBuffer;
        const percentageBuffer =
          totalUsersBuffer > 0
            ? ((toBePrintedBuffer / totalUsersBuffer) * 100).toFixed(2)
            : 0;

        setBufferRange(candidate);
        setBufferPendingCount(pendingBuffer);
        setBufferToBePrintedListCount(toBePrintedBuffer);
        setBufferPercentageValue(percentageBuffer);
        setBufferTotalPayout(Number(candidate.total_payout || 0));
      } else {
        setBufferRange(null);
        setBufferPendingCount(0);
        setBufferToBePrintedListCount(0);
        setBufferPercentageValue(0);
        setBufferTotalPayout(0);
      }

      // If we have a Buffer candidate, hide it from the Previous section
      const filteredPreviousRanges = candidate
        ? otherRanges.filter((range) => range.id !== candidate.id)
        : otherRanges;

      setPreviousRanges(filteredPreviousRanges);
    } catch (error) {
      console.error("Failed to fetch range date data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  function formatDate(dateString) {
    return moment(dateString).format("MMMM D, YYYY");
  }

  useEffect(() => {
    if (urlStartDate) {
      updateCurrentDate(urlStartDate);
      setStartDate(urlStartDate);
      setShowUserList(true);
    } else {
      updateCurrentDate(null);
    }
  }, []);

  // useEffect(() => {
  //     getRangeDateData(startDate);
  // }, [startDate]);

  function formatInvoiceAdditions(additions) {
    const numericValue = Number(additions);

    if (isNaN(numericValue) || numericValue % 1 !== 0) {
      // Check if it's a decimal
      const formattedValue = numericValue.toFixed(2); // Ensure 2 digits after the decimal point
      return formattedValue;
    } else {
      // If it's an integer, add .00 to make it a decimal with 2 digits after the decimal point
      return additions + ".00";
    }
  }

  function formatValue(value) {
    return value === "0.00" ? "-" : value;
  }

  const handleDeleteInvoice = async (id) => {
    guardAction(PERMISSIONS.DELETE, "delete invoice", async () => {
      const confirmed = window.confirm(
        "Are you sure you want to delete this invoice?"
      );
      if (!confirmed) return;

      setIsLoading(true);

      try {
        const response = await axios.post(`${apiUrl}/deleteGeneratedInvoice`, {
          invoiceId: id,
        });

        if (response.data && response.data.status === 1) {
          showMessage(response.data.message);
          window.location.reload();
        } else {
          showMessage("Error: " + response.data.message);
        }
      } catch (error) {
        showMessage("An unexpected error occurred");
        console.error("Delete invoice error:", error);
      } finally {
        setIsLoading(false);
      }
    });
  };

  const fetchPrintedUsers = async () => {
    if (!urlStartDate) {
      return;
    }
    if (rangeId == null) {
      return;
    }
    try {
      setprintedListLoading(true);
      const response = await axios.post(`${apiUrl}/getUsersWithInvoice`, {
        range_id: rangeId,
        page: currentPagePrinted,
        pageSize: pageSizePrinted,
        nameQuery: printedNameQuery,
      });

      setPrintedList(response.data.data);
      setTotalPrintedUsers(response.data.totalUsers); // Get total user count for pagination
    } catch (error) {
      console.error("Failed to fetch printed users:", error);
    } finally {
      setprintedListLoading(false);
    }
  };
  useEffect(() => {
    if (rangeId != null) {
      fetchPrintedUsers();
    }
  }, [currentPagePrinted, pageSizePrinted, rangeId]);

  const fetchArchivedUsers = async () => {
    if (!urlStartDate) {
      return;
    }
    if (rangeId == null) {
      return;
    }
    try {
      setarchivedListLoading(true);
      const response = await axios.post(
        `${apiUrl}/getUsersWithInvoiceArchived`,
        {
          range_id: rangeId,
          page: currentPageArchived,
          pageSize: pageSizeArchived,
          nameQuery: archivedNameQuery,
        }
      );

      setArchivedList(response.data.data);
      setTotalArchivedUsers(response.data.totalUsers); // Get total user count for pagination
    } catch (error) {
      console.error("Failed to fetch printed users:", error);
    } finally {
      setarchivedListLoading(false);
    }
  };

  const handleGenerateAllPdfs = () => {
    guardAction(PERMISSIONS.GENERATE_PDF, "generate PDFs", () => {
      navigate("/multipleInvoiceDetail?generate=archived&range_id=" + rangeId);
    });
  };

  useEffect(() => {
    if (rangeId != null) {
      fetchArchivedUsers();
    }
  }, [currentPageArchived, pageSizeArchived, rangeId]);

  const handleBlockUser = async (email) => {
    try {
      await axios.post(`${apiUrl}/block`, { email });
      const updatedUsers = users.map((user) => {
        if (user.email === email) {
          // Toggle the 'blocked' status
          user.blocked = !user.blocked;
        }
        return user;
      });
      setUsers(updatedUsers);
    } catch (error) {
      //console.error("Failed to block/unblock user:", error);
    }
  };

  const generatePreviousViewItems = (otherRanges) => {
    return otherRanges.map((range) => (
      <div
        onClick={() => updateRange(range.start_date)}
        key={range.id}
        className="previousInnerView"
      >
        <div className="previousInnerViewContainer">
          <img src={date} alt="date" className="rangleIcons" />
          <span className="admin-header-title">
            {formatDate(range.end_date)}
          </span>
        </div>
        <hr />
        <div className="previousInnerViewContainer">
          <img src={people} alt="people" className="rangleIcons" />
          <span className="admin-header-title">
            <strong>{range.total_invoice_generated}</strong>/{range.total_users}
          </span>
        </div>
      </div>
    ));
  };

  const handleDeleteUser = async (email) => {
    const confirmed = true;
    // const confirmed = window.confirm(
    //   `Are you sure you want to delete the user ${email}?`
    // );
    if (confirmed) {
      try {
        await axios.delete(`${apiUrl}/users/${email}`);
        // Update the users state by filtering out the deleted user
        const updatedUsers = users.filter((user) => user.email !== email);
        setUsers(updatedUsers);
      } catch (error) {
        //console.error("Failed to delete user:", error);
      }
    }
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(totalUsers / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const showMessage = (text) => {
    setMessage(text);

    // Hide the message after 2000 milliseconds (2 seconds)
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  const updateRange = (rangeId) => {
    const currentUrl = new URL(window.location.href);

    // Update or add the rangeId query parameter
    currentUrl.searchParams.set("rangeId", rangeId);

    // Redirect to the updated URL
    window.location.href = currentUrl.toString();
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPrinted = () => {
    if (currentPagePrinted < Math.ceil(totalPrintedUsers / pageSizePrinted)) {
      setCurrentPagePrinted(currentPagePrinted + 1);
    }
  };

  const handlePreviousPrinted = () => {
    if (currentPagePrinted > 1) {
      setCurrentPagePrinted(currentPagePrinted - 1);
    }
  };

  const handleNextArchived = () => {
    console.log("hehrheh");
    if (
      currentPageArchived < Math.ceil(totalArchivedUsers / pageSizeArchived)
    ) {
      setCurrentPageArchived(currentPageArchived + 1);
    }
  };

  const handlePreviousArchived = () => {
    if (currentPageArchived > 1) {
      setCurrentPageArchived(currentPageArchived - 1);
    }
  };

  const handleShowAllUsers = () => {
    setShowAllUsers(true);
    setSearchResult([]);
  };

  const [count, setCount] = useState(0);

  const fetchPendingUsers = async () => {
    if (!urlStartDate) {
      return;
    }
    if (rangeId == null) {
      return;
    }
    try {
      setUserListLoading(true);
      const response = await axios.post(`${apiUrl}/getPendingUsers`, {
        range_id: rangeId, // Pass the correct range_id
        page: currentPage,
        pageSize: pageSize,
        nameQuery: pendingNameQuery,
      });
      console.log(response.data);
      setUsers(response.data.data);
      setCount(response.data.totalPendingUsers || 0);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    } finally {
      setUserListLoading(false);
    }
  };

  const handlePendingSearch = () => {
    setCurrentPage(1);
    fetchPendingUsers();
  };

  const handlePrintedSearch = () => {
    setCurrentPagePrinted(1);
    fetchPrintedUsers();
  };

  const handleArchivedSearch = () => {
    setCurrentPageArchived(1);
    fetchArchivedUsers();
  };

  useEffect(() => {
    if (rangeId != null) {
      fetchPendingUsers();
    }
  }, [currentPage, pageSize, rangeId]);

  function ProgressBar({ percentage }) {
    return (
      <div
        style={{
          width: "90%",
          backgroundColor: "#e0e0e0",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${percentage}%`,
            height: "15px",
            backgroundColor: "#FFCACA",
            transition: "width 0.3s ease",
          }}
        />
        <span
          style={{
            position: "absolute",
            width: "100%",
            textAlign: "center",
            top: 0,
            color: "#ffffff",
          }}
        >
          {percentage}%
        </span>
      </div>
    );
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleZeroSubmission = async (id) => {
    const confirmed = window.confirm(
      `Are you sure you want to omit this user from paylist?`
    );

    if (!confirmed) {
      return;
    }

    if (!id) {
      showMessage("Please select a user.");
      return;
    }
    if (!rangeId) {
      showMessage("Please select a range.");
      return;
    }

    const values = {
      userId: id,
      payDateId: rangeId,
    };

    setIsLoading(true);
    // console.log(values);

    try {
      const response = await axios.post(`${apiUrl}/newZeroInvoice`, values);
      const data = response.data;
      if (response.status === 200) {
        if (data.status === 1) {
          showMessage(data.message);
          const currentUrl = new URL(window.location.href);

          // console.log(urlStartDate);
          currentUrl.searchParams.set("rangeId", urlStartDate);
          window.location.href = currentUrl.toString();
        } else {
          showMessage("Error: " + data.message);
        }
      } else {
        showMessage("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      showMessage("An error occured");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditYtdSubmit = async () => {
    try {
      // Use the new updateYTDFinal endpoint - user enters final YTD, system calculates adjustment
      setIsLoading(true);
      const response = await axios.post(`${apiUrl}/updateYTDFinal`, {
        invoiceId: selectedInvoiceId,
        newYTDFinal: parseFloat(editedYtdAmount),
      });

      const data = response.data;
      if (response.status === 200) {
        if (data.status === 1) {
          // alert("YTD Final updated successfully!");

          setIsYtdModalOpen(false);
          fetchPrintedUsers();
          //  setTimeout(() => {
          //   fetchPrintedUsers();
          // }, 500);
        } else {
          showMessage("Error: " + data.message);
        }
        // Refresh data here if needed
      } else {
        showMessage("Error: " + data.message);
      }
    } catch (err) {
      console.error(err);
      console.error("Error:", err);
      showMessage("An error occured");
    } finally {
      setIsLoading(false);
    }
  };

  const archiveInvoice = async (id, type = "archive") => {
    const actionLabel =
      type === "unarchive" ? "unarchive invoice" : "archive invoice";

    guardAction(PERMISSIONS.ARCHIVE, actionLabel, async () => {
      if (!id) {
        showMessage("Please select a invoice.");
        return;
      }
      let title = "Are you sure you want to archive this invoice?";
      if (type == "unarchive") {
        title = "Are you sure you want to un-archive this invoice?";
      }

      const confirmed = window.confirm(title);

      if (!confirmed) {
        return;
      }

      const values = {
        invoiceId: id,
        type: type,
      };

      setIsLoading(true);

      try {
        const response = await axios.post(`${apiUrl}/archiveInvoice`, values);
        const data = response.data;
        if (response.status === 200) {
          if (data.status === 1) {
            showMessage(data.message);
            const currentUrl = new URL(window.location.href);

            currentUrl.searchParams.set("rangeId", urlStartDate);
            window.location.href = currentUrl.toString();
          } else {
            showMessage("Error: " + data.message);
          }
        } else {
          showMessage("Error: " + data.message);
        }
      } catch (error) {
        console.error("Error:", error);
        showMessage("An error occured");
      } finally {
        setIsLoading(false);
      }
    });
  };

  const handleShowUserList = () => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("rangeId", startDate);
    window.location.href = currentUrl.toString();
  };
  const samePageRefresh = () => {
    window.location.href = "/dashboard";
  };

  return (
    <div className="admin-panel-parent-container">
      <PermissionDialog />
      <NavBar />
      <TopNavBar />
      {message && (
        <div className="custom-modal">
          <div className="modal-content">{message}</div>
        </div>
      )}
      {isYtdModalOpen && currentInvoiceData && (
        <div className="custom-modal">
          <div className="modal-content-ytd" style={{ minWidth: "400px" }}>
            <h3 style={{ marginBottom: "16px" }}>Edit YTD Amount</h3>

            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "bold",
                fontSize: "15px",
              }}
            >
              YTD Amount:
            </label>
            <input
              type="number"
              step="0.01"
              value={editedYtdAmount}
              onChange={(e) => setEditedYtdAmount(e.target.value)}
              placeholder="Enter YTD amount"
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "16px",
                fontSize: "15px",
                border: "2px solid #2E8056",
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                className="edit-ytd-submit"
                onClick={() => setIsYtdModalOpen(false)}
              >
                Cancel
              </button>
              <button className="edit-ytd-submit" onClick={handleEditYtdSubmit}>
                Update
              </button>
            </div>
          </div>
        </div>
      )}
      {isLoading ? (
        <div className="spinner-container">
          <TailSpin
            type="TailSpin"
            color="rgb(155, 236, 34)"
            height={70}
            width={70}
            timeout={5000}
          />
        </div>
      ) : (
        <div className="admin-card admin-panel">
          <div className="admin-card-body">
            <div className="admin-header">
              <div className="left-section">
                <h1 className="admin-header-title">
                  <span
                    className="admin-card-title-span"
                    style={{ cursor: "pointer" }}
                    onClick={samePageRefresh}
                  >
                    Dashboard
                  </span>
                  <span style={{ margin: "0 8px" }}> &gt; </span>
                  <span>
                    {currentActive === "active" ? "Current" : "Previous"}
                  </span>
                </h1>
              </div>
              <div className="right-section">
                {/* <Search onSearch={handleSearch} /> */}
                <Link
                  to="/addEmployee"
                  className="add-user-link small-screen-link"
                >
                  <div className="add-user-container">
                    <img
                      src={addEmployeeIcon}
                      alt="Manage employee Icon"
                      className="addEmployeeIcon"
                    />
                    <span className="add-employee-text"> Add Employee</span>
                  </div>
                </Link>
              </div>
            </div>
            <div className="currentView" onClick={handleShowUserList}>
              <span className="admin-header-title">Current</span>
              <div className="inner-header-box">
                <div className="inner-row-box">
                  <div className="dateRange innerBox">
                    <img src={date} alt="date" className="rangleIcons" />
                    <div className="inner-date-range">
                      <p className="currentText">Date</p>
                      <p className="currentText currentDownText">
                        {formatDate(endDate)}
                      </p>
                    </div>
                  </div>
                  <div class="vertical-line"></div>
                  <div className="dateRange innerBox">
                    <img src={people} alt="people" className="rangleIcons" />
                    <div className="inner-date-range">
                      <p className="currentText">Total Employees</p>
                      <p className="currentText currentDownText">
                        {totalUsers}
                      </p>
                    </div>
                  </div>
                  <div class="vertical-line"></div>
                  <div className="dateRange innerBox">
                    <img src={history} alt="history" className="rangleIcons" />
                    <div className="inner-date-range">
                      <p className="currentText">Pending Pay Slip</p>
                      <p className="currentText currentDownText">
                        {pendingCount}
                      </p>
                    </div>
                  </div>
                  <div class="vertical-line"></div>
                  <div className="dateRange innerBox">
                    <img src={printer} alt="printer" className="rangleIcons" />
                    <div className="inner-date-range">
                      <p className="currentText">To Be printed</p>
                      <p className="currentText currentDownText">
                        {toBePrintedListCount}
                      </p>
                    </div>
                  </div>
                  <div class="vertical-line"></div>
                  <div className="dateRange innerBox">
                    <img src={history} alt="payout" className="rangleIcons" />
                    <div className="inner-date-range">
                      <p className="currentText">Total Payout</p>
                      <p className="currentText currentDownText">
                        ${totalPayout.toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="progressBarContainer">
                  <ProgressBar percentage={percentageValue} />
                  <span className="showPercentage">{percentageValue}%</span>
                </div>
              </div>
            </div>
            {bufferRange && (
              <div
                className="currentView"
                onClick={() => updateRange(bufferRange.start_date)}
              >
                <span className="admin-header-title">Buffer</span>
                <div className="inner-header-box">
                  <div className="inner-row-box">
                    <div className="dateRange innerBox">
                      <img src={date} alt="date" className="rangleIcons" />
                      <div className="inner-date-range">
                        <p className="currentText">Date</p>
                        <p className="currentText currentDownText">
                          {formatDate(bufferRange.end_date)}
                        </p>
                      </div>
                    </div>
                    <div class="vertical-line"></div>
                    <div className="dateRange innerBox">
                      <img src={people} alt="people" className="rangleIcons" />
                      <div className="inner-date-range">
                        <p className="currentText">Total Employees</p>
                        <p className="currentText currentDownText">
                          {bufferRange.total_users}
                        </p>
                      </div>
                    </div>
                    <div class="vertical-line"></div>
                    <div className="dateRange innerBox">
                      <img
                        src={history}
                        alt="history"
                        className="rangleIcons"
                      />
                      <div className="inner-date-range">
                        <p className="currentText">Pending Pay Slip</p>
                        <p className="currentText currentDownText">
                          {bufferPendingCount}
                        </p>
                      </div>
                    </div>
                    <div class="vertical-line"></div>
                    <div className="dateRange innerBox">
                      <img
                        src={printer}
                        alt="printer"
                        className="rangleIcons"
                      />
                      <div className="inner-date-range">
                        <p className="currentText">To Be printed</p>
                        <p className="currentText currentDownText">
                          {bufferToBePrintedListCount}
                        </p>
                      </div>
                    </div>
                    <div class="vertical-line"></div>
                    <div className="dateRange innerBox">
                      <img src={history} alt="payout" className="rangleIcons" />
                      <div className="inner-date-range">
                        <p className="currentText">Total Payout</p>
                        <p className="currentText currentDownText">
                          ${bufferTotalPayout.toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="progressBarContainer">
                    <ProgressBar percentage={bufferPercentageValue} />
                    <span className="showPercentage">
                      {bufferPercentageValue}%
                    </span>
                  </div>
                </div>
              </div>
            )}
            <hr />
            {!showUserList && (
              <div className="previousView">
                <span className="admin-header-title">Previous</span>
                <div className="grid-container previousContainer">
                  {generatePreviousViewItems(previousRanges)}
                </div>
              </div>
            )}
            {showUserList && (
              <div className="previousView">
                <span className="admin-header-title">Pending Paylist</span>
                <div style={{ display: "flex", gap: "8px", margin: "8px 0" }}>
                  <input
                    type="text"
                    placeholder="Search by employee name"
                    value={pendingNameQuery}
                    onChange={(e) => setPendingNameQuery(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handlePendingSearch();
                    }}
                    style={{
                      padding: "8px",
                      minWidth: "260px",
                      height: "36px", // give a fixed height to match button
                      borderRadius: "8px",
                      boxSizing: "border-box", // ensures padding doesn't break layout
                      border: "1px solid #ccc",
                    }}
                  />
                  <button
                    onClick={handlePendingSearch}
                    style={{
                      backgroundColor: "#2E8056",
                      color: "#fff",
                      padding: "8px 16px",
                      height: "36px",
                      border: "none",
                      cursor: "pointer",
                      borderRadius: "8px",
                    }}
                  >
                    Search
                  </button>
                </div>

                {searchResult.length > 0 && (
                  <div className="show-all-users-container">
                    <button
                      onClick={handleShowAllUsers}
                      className="show-all-users-button"
                    >
                      Show All Users
                    </button>
                  </div>
                )}
                {userListLoading ? (
                  //  <table className="user-table">
                  <div className="spinner-container">
                    <TailSpin
                      type="TailSpin"
                      color="rgb(155, 236, 34)"
                      height={70}
                      width={70}
                      timeout={5000}
                    />
                  </div>
                ) : (
                  // </table>
                  <UserList
                    users={users}
                    onBlockUser={handleBlockUser}
                    onZeroSubmission={handleZeroSubmission}
                    showZeroSubmisson={true}
                    onDeleteUser={handleDeleteUser}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    showActionLinks={false}
                    startDate={startDate}
                    endDate={endDate}
                    rangeId={rangeId}
                  />
                )}
                {users.length > 0 && (
                  <div className="pagination-controls">
                    <button
                      onClick={handlePrevious}
                      disabled={currentPage === 1}
                      className="pagination-button"
                    >
                      Previous
                    </button>

                    <span className="current-page">
                      Page {currentPage} of {Math.ceil(count / pageSize)}
                    </span>

                    <button
                      onClick={handleNext}
                      disabled={currentPage === Math.ceil(count / pageSize)}
                      className="pagination-button"
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
            <hr />
            {showUserList && (
              <div className="previousView">
                <span className="admin-header-title">To Be Printed</span>
                <div style={{ display: "flex", gap: "8px", margin: "8px 0" }}>
                  <input
                    type="text"
                    placeholder="Search by employee name"
                    value={printedNameQuery}
                    onChange={(e) => setPrintedNameQuery(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handlePrintedSearch();
                    }}
                    style={{
                      padding: "8px",
                      minWidth: "260px",
                      height: "36px", // give a fixed height to match button
                      borderRadius: "8px",
                      boxSizing: "border-box", // ensures padding doesn't break layout
                      border: "1px solid #ccc",
                    }}
                  />
                  <button
                    style={{
                      backgroundColor: "#2E8056",
                      color: "#fff",
                      padding: "8px 16px",
                      height: "36px",
                      border: "none",
                      cursor: "pointer",
                      borderRadius: "8px",
                    }}
                    onClick={handlePrintedSearch}
                  >
                    Search
                  </button>
                </div>

                <div className="user-list user-list-margin">
                  <table className="invoice-table even-invoice-table">
                    <thead>
                      <tr className="printedListHeader">
                        <th>Invoice Id</th>
                        <th>Employee Id</th>
                        <th>Name</th>
                        <th>Pay Period</th>
                        <th>Pay Rate($)</th>
                        <th>Salary($)</th>
                        <th>Hours</th>
                        <th>Additions($)</th>
                        <th>Deductions($)</th>
                        <th>Amount($)</th>
                        <th>YTD Amount($)</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {printedListLoading ? (
                        <tr>
                          <td colSpan="13" style={{ textAlign: "center" }}>
                            {/* Add your loader here */}
                            <div className="spinner-container">
                              {/* Spinner component here */}
                            </div>
                          </td>
                        </tr>
                      ) : printedList.length === 0 ? (
                        <tr>
                          <td
                            colSpan="13"
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            No paylist generated yet
                          </td>
                        </tr>
                      ) : (
                        printedList.map((invoice) => (
                          <tr key={invoice.id}>
                            <td>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                #{invoice.id}
                              </Link>
                            </td>
                            <td>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                #{invoice.userId}
                              </Link>
                            </td>
                            <td>
                              <div className="user-container">
                                {invoice.image ? (
                                  <div className="invoice-list-image">
                                    <img
                                      src={invoice.image}
                                      alt="Employee Image"
                                    />
                                  </div>
                                ) : (
                                  <div className="invoice-list-image">
                                    <img
                                      src={DefaultEmployeeProfile}
                                      alt="Default Employee Image"
                                    />
                                  </div>
                                )}
                                <Link
                                  to={`/invoiceDetail`}
                                  state={invoice.id}
                                  className="user-link"
                                >
                                  {invoice.name}
                                </Link>
                              </div>
                            </td>
                            <td>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                {invoice.payPeriod}
                              </Link>
                            </td>
                            <td>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                {formatInvoiceAdditions(invoice.payRate)}
                              </Link>
                            </td>
                            <td>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                {invoice.salary === undefined ||
                                invoice.salary === "" ||
                                invoice.salary === null
                                  ? "-"
                                  : formatInvoiceAdditions(invoice.salary)}
                              </Link>
                            </td>
                            <td>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                {formatValue(
                                  invoice.hours +
                                    ":" +
                                    invoice.minutes.toString().padStart(2, "0")
                                )}
                              </Link>
                            </td>
                            <td>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                {formatValue(
                                  formatInvoiceAdditions(invoice.Additions)
                                )}
                              </Link>
                            </td>
                            <td>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                {formatValue(
                                  formatInvoiceAdditions(invoice.Deductions)
                                )}
                              </Link>
                            </td>
                            <td>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                {formatInvoiceAdditions(invoice.Amount)}
                              </Link>
                            </td>
                            <td>
                              <button
                                onClick={() => {
                                  guardAction(
                                    PERMISSIONS.MANAGE_YTD,
                                    "edit YTD amount",
                                    () => {
                                      setIsYtdModalOpen(true);
                                      setSelectedInvoiceId(invoice.id);
                                      setCurrentInvoiceData(invoice);
                                      setEditedYtdAmount(
                                        invoice.YTDFinal || invoice.YTDAmount || 0
                                      );
                                    }
                                  );
                                }}
                                style={{
                                  background: "none",
                                  border: "none",
                                  marginLeft: "8px",
                                  cursor: "pointer",
                                }}
                                className={deniedActionClass(canManageYtd)}
                                title="Edit YTD Amount"
                              >
                                ✏️
                              </button>
                              <Link
                                to={`/invoiceDetail`}
                                state={invoice.id}
                                className="user-link"
                              >
                                {formatInvoiceAdditions(
                                  invoice.YTDFinal || invoice.YTDAmount
                                )}
                              </Link>
                            </td>
                            <td
                              style={{ width: "95px" }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Tippy content="Archive Invoice">
                                <img
                                  src={archive}
                                  alt="Archive Icon"
                                  style={{ width: "16px" }}
                                  className={`delete-icon admin-panel-icon ${deniedActionClass(canArchiveInvoice)}`}
                                  onClick={() => archiveInvoice(invoice.id)}
                                />
                              </Tippy>

                              <Link
                                to={"/editInvoice?id=" + invoice.id}
                                state={invoice.id}
                                className={`user-link icon-margin ${deniedActionClass(canEditInvoice)}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  guardAction(PERMISSIONS.EDIT, "edit invoice", () => {
                                    navigate("/editInvoice?id=" + invoice.id, {
                                      state: invoice.id,
                                    });
                                  });
                                }}
                              >
                                <Tippy content="Edit Invoice">
                                  <img
                                    src={editIcon}
                                    style={{ width: "15px" }}
                                    alt="Edit Icon"
                                    className="edit-icon admin-panel-icon"
                                  />
                                </Tippy>
                              </Link>
                              <Tippy content="Delete Invoice">
                                <img
                                  src={deleteIcon}
                                  alt="Delete Icon"
                                  style={{ width: "15px" }}
                                  className={`delete-icon admin-panel-icon ${deniedActionClass(canDeleteInvoice)}`}
                                  onClick={() =>
                                    handleDeleteInvoice(invoice.id)
                                  }
                                />
                              </Tippy>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-controls">
                  <button
                    onClick={handlePreviousPrinted}
                    disabled={currentPagePrinted === 1}
                    className="pagination-button"
                  >
                    Previous
                  </button>

                  <span className="current-page">
                    Page {currentPagePrinted} of{" "}
                    {Math.ceil(totalPrintedUsers / pageSizePrinted)}
                  </span>

                  <button
                    onClick={handleNextPrinted}
                    disabled={
                      currentPagePrinted ===
                      Math.ceil(totalPrintedUsers / pageSizePrinted)
                    }
                    className="pagination-button"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
            {/* archived list */}
            {showUserList && (
              <div>
                {/* <div
        onClick={() => setIsArchivedOpen(!isArchivedOpen)}
        className="admin-archived-title"
        style={{
          cursor: "pointer",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          // justifyContent: "space-between",
        }}
      >
        <span>Archived List</span>
        <span>{isArchivedOpen ? "▲" : "▼"}</span>
      </div> */}

                <div className="previousView">
                  <span
                    style={{
                      cursor: "pointer",
                      userSelect: "none",
                      display: "flex",
                      alignItems: "center",
                      // justifyContent: "space-between",
                    }}
                    onClick={() => setIsArchivedOpen(!isArchivedOpen)}
                    className="admin-header-title"
                  >
                    Archived List
                    <span style={{ marginLeft: "10px" }}>
                      {isArchivedOpen ? "▼" : "▲"}
                    </span>
                    <span>
                      <button
                        style={{
                          marginLeft: "5px",
                          display: "inline",
                          marginTop: "0px",
                        }}
                        className={`custom-button ${deniedActionClass(canGeneratePdf)}`}
                        onClick={handleGenerateAllPdfs}
                      >
                        Generate All Pdfs
                      </button>
                    </span>
                  </span>

                  {isArchivedOpen && (
                    <div>
                      <div
                        style={{ display: "flex", gap: "8px", margin: "8px 0" }}
                      >
                        <input
                          type="text"
                          placeholder="Search by employee name"
                          value={archivedNameQuery}
                          onChange={(e) => setArchivedNameQuery(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleArchivedSearch();
                          }}
                          style={{
                            padding: "8px",
                            minWidth: "260px",
                            height: "36px", // give a fixed height to match button
                            borderRadius: "8px",
                            boxSizing: "border-box", // ensures padding doesn't break layout
                            border: "1px solid #ccc",
                          }}
                        />
                        <button
                          style={{
                            backgroundColor: "#2E8056",
                            color: "#fff",
                            padding: "8px 16px",
                            height: "36px",
                            border: "none",
                            cursor: "pointer",
                            borderRadius: "8px",
                          }}
                          onClick={handleArchivedSearch}
                        >
                          Search
                        </button>
                      </div>
                      <div className="user-list user-list-margin">
                        {archivedListLoading && (
                          <div className="archivedTable-loaderOverlay">
                            <div className="spinner-container">
                              <TailSpin
                                type="TailSpin"
                                color="rgb(155, 236, 34)"
                                height={70}
                                width={70}
                                timeout={5000}
                              />
                            </div>
                          </div>
                        )}
                        <table className="invoice-table even-invoice-table">
                          <thead>
                            <tr className="printedListHeader">
                              <th>Invoice Id</th>
                              <th>Employee Id</th>
                              <th>Name</th>
                              <th>Pay Period</th>
                              <th>Pay Rate($)</th>
                              <th>Salary($)</th>
                              <th>Hours</th>
                              <th>Additions($)</th>
                              <th>Deductions($)</th>
                              <th>Amount($)</th>
                              <th>YTD Amount($)</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {archivedList.length === 0 ? (
                              <tr>
                                <td
                                  colSpan="13"
                                  style={{
                                    textAlign: "center",
                                    padding: "20px",
                                  }}
                                >
                                  No archived payslip yet
                                </td>
                              </tr>
                            ) : (
                              archivedList.map((invoice) => (
                                <tr key={invoice.id}>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      #{invoice.id}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      #{invoice.userId}
                                    </Link>
                                  </td>
                                  <td>
                                    <div className="user-container">
                                      {invoice.image ? (
                                        <div className="invoice-list-image">
                                          <img
                                            src={invoice.image}
                                            alt="Employee Image"
                                          />
                                        </div>
                                      ) : (
                                        <div className="invoice-list-image">
                                          <img
                                            src={DefaultEmployeeProfile}
                                            alt="Default Employee Image"
                                          />
                                        </div>
                                      )}
                                      <Link
                                        to={`/invoiceDetail`}
                                        state={invoice.id}
                                        className="user-link"
                                      >
                                        {invoice.name}
                                      </Link>
                                    </div>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      {invoice.payPeriod}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      {formatInvoiceAdditions(invoice.payRate)}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      {invoice.salary === undefined ||
                                      invoice.salary === "" ||
                                      invoice.salary === null
                                        ? "-"
                                        : formatInvoiceAdditions(
                                            invoice.salary
                                          )}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      {formatValue(
                                        invoice.hours +
                                          ":" +
                                          invoice.minutes
                                            .toString()
                                            .padStart(2, "0")
                                      )}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      {formatValue(
                                        formatInvoiceAdditions(
                                          invoice.Additions
                                        )
                                      )}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      {formatValue(
                                        formatInvoiceAdditions(
                                          invoice.Deductions
                                        )
                                      )}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      {formatInvoiceAdditions(invoice.Amount)}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/invoiceDetail`}
                                      state={invoice.id}
                                      className="user-link"
                                    >
                                      {formatInvoiceAdditions(
                                        invoice.YTDFinal || invoice.YTDAmount
                                      )}
                                    </Link>
                                  </td>
                                  <td
                                    style={{ width: "95px" }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <Tippy content="Unarchive Invoice">
                                      <img
                                        src={unarchiveIcon}
                                        style={{ width: "15px" }}
                                        alt="Edit Icon"
                                        className={`edit-icon admin-panel-icon ${deniedActionClass(canArchiveInvoice)}`}
                                        onClick={() =>
                                          archiveInvoice(
                                            invoice.id,
                                            "unarchive"
                                          )
                                        }
                                      />
                                    </Tippy>
                                    <Tippy content="Delete Invoice">
                                      <img
                                        src={deleteIcon}
                                        alt="Delete Icon"
                                        style={{ width: "15px" }}
                                        className={`delete-icon admin-panel-icon ${deniedActionClass(canDeleteInvoice)}`}
                                        onClick={() =>
                                          handleDeleteInvoice(invoice.id)
                                        }
                                      />
                                    </Tippy>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                      {/* Pagination Controls */}
                      <div className="pagination-controls">
                        <button
                          onClick={handlePreviousArchived}
                          disabled={currentPageArchived === 1}
                          className="pagination-button"
                        >
                          Previous
                        </button>

                        <span className="current-page">
                          Page {currentPageArchived} of{" "}
                          {Math.ceil(totalArchivedUsers / pageSizeArchived)}
                        </span>

                        <button
                          onClick={handleNextArchived}
                          disabled={
                            currentPageArchived ===
                            Math.ceil(totalArchivedUsers / pageSizeArchived)
                          }
                          className="pagination-button"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
